import {defineSlotRecipe} from '@chakra-ui/react3'

export const sliderSlotRecipe = defineSlotRecipe({
    className: 'slider',
    slots: [
        'sliderContainer',
        'controlsContainer',
        'pagination',
        'slide',
        'videoControlContainer',
        'scrollContainer'
    ],

    base: {
        sliderContainer: {
            position: 'relative',
            flexDirection: 'column-reverse',
            overflow: 'visible'
        },
        scrollContainer: {
            overflowX: 'auto',
            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
            '&::-webkit-scrollbar': {display: 'none'},
            touchAction: 'none',
            WebkitOverflowScrolling: 'touch',
            // for full visible focus indicator for (first) visible element
            paddingLeft: 'spacing-4',
            scrollPaddingLeft: 'spacing-4',
            paddingY: 'spacing-4'
        },
        controlsContainer: {
            paddingTop: 'spacing-40',
            zIndex: 2
        },
        slide: {
            flex: '0 0 auto',
            height: 'auto',
            position: 'relative',
            overflow: 'visible',
            img: {pointerEvents: 'none', userSelect: 'none', draggable: false}
        },
        pagination: {gap: '2px', justifyContent: 'center'}
    },

    variants: {
        variant: {
            default: {
                controlsContainer: {justifyContent: 'flex-end'},
                scrollContainer: {
                    paddingRight: 'max(0px, calc((100vw - 100%) / 2))',
                    marginRight: 'calc(-1 * max(0px, calc((100vw - 100%) / 2)))',
                    scrollPaddingRight: 'max(0px, calc((100vw - 100%) / 2))'
                },
                pagination: {display: 'none'}
            },
            gallery: {
                controlsContainer: {
                    flexDirection: {base: 'row-reverse', s: 'revert'},
                    justifyContent: 'space-between',
                    position: 'absolute',
                    left: 'spacing-32',
                    bottom: 'spacing-32',
                    right: {base: 'spacing-32', s: 'auto'},
                    gap: {base: 0, s: 'spacing-32'}
                },
                videoControlContainer: {
                    position: {base: 'absolute', s: 'relative'},
                    top: 'spacing-8',
                    right: 'spacing-8',
                    zIndex: '1'
                },
                pagination: {}
            }
        }
    },

    defaultVariants: {variant: 'default'}
})
